import {
	ArrayInput,
	AutocompleteInput,
	BooleanInput,
	CheckboxGroupInput,
	FileField,
	FileInput,
	ImageField,
	ImageInput,
	NumberInput,
	ReferenceArrayInput,
	ReferenceInput,
	required,
	SelectArrayInput,
	SelectInput,
	SimpleFormIterator,
	TextInput,
	useTranslate
} from 'react-admin';
import { useFormContext } from 'react-hook-form';
import {
	Chip,
	Divider,
	InputAdornment,
	Stack,
	Typography,
	useMediaQuery,
	useTheme
} from '@mui/material';
import {
	contactInputText,
	contactOptionText
} from '../../../../misc/ContactOption';
import { PriceByAreaInputs } from '../../../components/PriceByAreaInputs';
import { INPUT_SOURCE, OBJECTS_TYPES, SALE_RENT_TYPE } from '../../../constants';

const PlacementSectionInputs = () => {
	const translate = useTranslate();

	return (
		<Stack gap={1}>
			<Typography variant="h6">Розміщення</Typography>
			<TextInput source={INPUT_SOURCE.NAME} label="form.fields.name" />
			<TextInput
				source="property_type"
				defaultValue={OBJECTS_TYPES.COMMERCES}
				style={{ display: 'none' }}
			/>
			{/*<ReferenceInput*/}
			{/*	source={INPUT_SOURCE.COMPLEX_ID}*/}
			{/*	reference="complexes"*/}
			{/*	label="Комплекс"*/}
			{/*>*/}
			{/*	<AutocompleteInput*/}
			{/*		optionText="name"*/}
			{/*		label="Комплекс"*/}
			{/*		onCreate={() => {}}*/}
			{/*	/>*/}
			{/*</ReferenceInput>*/}
			{/*<ReferenceInput source={INPUT_SOURCE.BUILDING_ID} reference="buildings">*/}
			{/*	<AutocompleteInput*/}
			{/*		optionText="name"*/}
			{/*		label="Будівля"*/}
			{/*		onCreate={() => {}}*/}
			{/*		validate={required()}*/}
			{/*	/>*/}
			{/*</ReferenceInput>*/}
			<Stack gap={2} direction="row" alignItems="center">
				<Stack direction="row" alignItems="center">
					<NumberInput
						source={INPUT_SOURCE.AREA}
						label="form.fields.area"
						slotProps={{
							input: {
								endAdornment: (
									<InputAdornment position="start">м²</InputAdornment>
								)
							}
						}}
						validate={required()}
					/>
				</Stack>
				<Stack>
					<NumberInput
						source={INPUT_SOURCE.FLOOR}
						label="form.fields.floor"
						validate={required()}
					/>
				</Stack>
				<Stack>
					<BooleanInput source={INPUT_SOURCE.FACADE} label="Фасад" />
				</Stack>
			</Stack>
			<SelectInput
				source={INPUT_SOURCE.STATE}
				label="form.fields.state"
				choices={[
					{ id: 1, name: 'Бетон' },
					{ id: 2, name: 'Ремонт після орендаря' },
					{
						id: 3,
						name: 'Новий базовий ремонт'
					},
					{ id: 4, name: 'Новий дизайнерський ремонт' }
				]}
				validate={required()}
			/>
			<CheckboxGroupInput
				source={INPUT_SOURCE.OBJECT_ACTIONS}
				label="form.fields.objectActions"
				choices={[
					{ id: SALE_RENT_TYPE.RENT, name: 'form.fields.rent' },
					{ id: SALE_RENT_TYPE.SALE, name: 'form.fields.sale' }
				]}
			/>
		</Stack>
	);
};

const DescriptionSectionInputs = () => {
	const { watch } = useFormContext();
	const objectActions: string[] = watch(INPUT_SOURCE.OBJECT_ACTIONS);
	const translate = useTranslate();

	return (
		<Stack gap={1}>
			{objectActions?.map(action => (
				<PriceByAreaInputs
					key={action}
					title={translate(`form.fields.${action}`)}
					priceType={action}
				/>
			))}
			<TextInput
				source={INPUT_SOURCE.FURNISHING}
				label="Меблювання"
				helperText={false}
				multiline={true}
			/>
		</Stack>
	);
};
const DocumentsSectionInputs = () => {
	return (
		<Stack gap={2}>
			<Typography variant="h6">Документи</Typography>
			<ImageInput
				label="Фото"
				source={INPUT_SOURCE.IMAGES}
				multiple={true}
				placeholder={
					<p>Натисніть або перетягніть кілька фото, щоб завантажити</p>
				}
				helperText={false}
			>
				<ImageField source="src" title="title" />
			</ImageInput>
			<FileInput
				label="Відео"
				source={INPUT_SOURCE.VIDEOS}
				multiple={true}
				placeholder={
					<p>Натисніть або перетягніть кілька відео, щоб завантажити</p>
				}
				helperText={false}
				accept={{
					'video/*': []
				}}
			>
				<FileField source="src" title="title" />
			</FileInput>
			<ImageInput
				label="Планування"
				source={INPUT_SOURCE.LAYOUT}
				placeholder={<p>Натисніть або перетягніть фото, щоб завантажити</p>}
				helperText={false}
			>
				<ImageField source="src" title="title" />
			</ImageInput>
			<FileInput
				label="Документи"
				multiple={true}
				source={INPUT_SOURCE.DOCUMENTS}
				placeholder={
					<p>Натисніть або перетягніть кілька документів, щоб завантажити</p>
				}
				helperText={false}
				accept={{
					'text/*': []
				}}
			>
				<FileField source="src" title="title" />
			</FileInput>
		</Stack>
	);
};

export const ContactsSectionInputs = () => {
	return (
		<>
			<TextInput
				source={INPUT_SOURCE.COMMENTS}
				label="Коментарі"
				helperText={false}
				multiline={true}
			/>
			<ArrayInput
				source={INPUT_SOURCE.CONTACTS_JSONB}
				label="Контакти"
				helperText={false}
			>
				<SimpleFormIterator inline disableReordering>
					<ReferenceArrayInput
						source={INPUT_SOURCE.CONTACT_ID}
						reference="contacts_summary"
					>
						<AutocompleteInput
							label="Контакт"
							optionText={contactOptionText}
							inputText={contactInputText}
							helperText={false}
							validate={required()}
							onCreate={() => {}}
						/>
					</ReferenceArrayInput>
					<ReferenceArrayInput
						resource="objects"
						source={INPUT_SOURCE.TAGS}
						reference="tags"
					>
						<SelectArrayInput
							label="Ролі"
							optionText={({ name, color }) => (
								<Chip
									label={name}
									size="small"
									style={{
										backgroundColor: color,
										border: 0
									}}
								/>
							)}
							helperText={false}
							onCreate={() => {}}
							sx={{
								width: 200,
								minWidth: 200,
								'& .RaSelectArrayInput-chip': {
									backgroundColor: 'transparent'
								}
							}}
						/>
					</ReferenceArrayInput>
				</SimpleFormIterator>
			</ArrayInput>
			<Stack>
				<Typography variant="h6">Акаунт менеджер</Typography>
				<ReferenceInput
					source={INPUT_SOURCE.SALES_ID}
					reference="sales"
					filter={{
						'disabled@neq': true
					}}
				>
					<SelectInput
						label="Акаунт менеджер"
						helperText={false}
						optionText={choice => `${choice.first_name} ${choice.last_name}`}
						validate={required()}
					/>
				</ReferenceInput>
			</Stack>
		</>
	);
};

export const CommerceInputs = () => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('md'));

	return (
		<Stack gap={2} p={1}>
			<Stack gap={3} direction={isMobile ? 'column' : 'row'}>
				<Stack gap={3} flex={5}>
					<PlacementSectionInputs />
					<DescriptionSectionInputs />
				</Stack>
				<Divider orientation={isMobile ? 'horizontal' : 'vertical'} flexItem />
				<Stack gap={4} flex={5}>
					{/*<DocumentsSectionInputs />*/}
					{/*<ContactsSectionInputs />*/}
				</Stack>
			</Stack>
		</Stack>
	);
};
